export const BURNING = 'burning';
export const FERTILISING = 'fertilising';
export const HARVESTING = 'harvesting';
export const PLANTING = 'planting';
export const SPRAYING = 'spraying';
